/**
 * Persistence keys for settings
 */

export const SETTINGS_STORAGE_KEY = "aitu_schedule_settings_v1";

/**
 * IndexedDB keys (if needed in future)
 */
export const IDB_STORE_NAMES = {
  SETTINGS: "settings",
  EVENTS: "events",
  DONE: "done",
} as const;

/**
 * localStorage keys
 */
export const LS_KEYS = {
  SETTINGS: SETTINGS_STORAGE_KEY,
  DONE: "aitu_schedule_done_v1",
  MAP_ROOM: "aitu_schedule_map_focus_room_v1",
  ICS_CACHE: "aitu_schedule_ics_cache_v1",
} as const;
